import React from 'react'

import { ActionStrip, WebViewActionStrip } from '@acorns/web-components'

type Props = {
  isWebView: boolean
  handleBackPress: () => void
}

export const CloseAccountEdgeCaseActionStripWrapper: React.SFC<Props> = (
  props,
) => (
  <>
    {props.isWebView ? (
      <WebViewActionStrip
        title={undefined}
        action={{
          onClick: props.handleBackPress,
          shouldShowCloseIcon: false,
        }}
      />
    ) : (
      <ActionStrip
        maxWidth={800}
        actionText="Go back to Settings"
        title="My subscription"
        onBack={props.handleBackPress}
        backOverride={undefined}
        showBack={true}
      />
    )}

    {props.children}

    {/* render child - which should come from the product specific index page */}
  </>
)
